var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1772_25929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1772_25929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6252 24.9654C16.1779 25.4126 15.6238 25.6362 14.9627 25.6362C14.3016 25.6362 13.7474 25.4126 13.3002 24.9654L3.0335 14.6987C2.81961 14.4848 2.64947 14.232 2.52308 13.9404C2.39669 13.6487 2.3335 13.3376 2.3335 13.007V4.66536C2.3335 4.0237 2.56197 3.47439 3.01891 3.01745C3.47586 2.5605 4.02516 2.33203 4.66683 2.33203H13.0085C13.3391 2.33203 13.6502 2.39523 13.9418 2.52161C14.2335 2.648 14.4863 2.81814 14.7002 3.03203L24.9668 13.3279C25.4141 13.7751 25.6377 14.3244 25.6377 14.9758C25.6377 15.6272 25.4141 16.1765 24.9668 16.6237L16.6252 24.9654ZM14.9627 23.332L23.3043 14.9904L13.0085 4.66536H4.66683V13.007L14.9627 23.332ZM7.5835 9.33203C8.06961 9.33203 8.4828 9.16189 8.82308 8.82162C9.16336 8.48134 9.3335 8.06814 9.3335 7.58203C9.3335 7.09592 9.16336 6.68273 8.82308 6.34245C8.4828 6.00217 8.06961 5.83203 7.5835 5.83203C7.09739 5.83203 6.68419 6.00217 6.34391 6.34245C6.00364 6.68273 5.8335 7.09592 5.8335 7.58203C5.8335 8.06814 6.00364 8.48134 6.34391 8.82162C6.68419 9.16189 7.09739 9.33203 7.5835 9.33203Z",
    fill: "#484D63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSell);
export default __webpack_public_path__ + "static/media/icon_sell.e61f879390ff472e078e6f27a9ddddff.svg";
export { ForwardRef as ReactComponent };